import { ApiError, get, post } from "./api";
import { h } from "./util";
import { I } from "./icons";

export type Me = { id: string; email: string };

export async function loadMe(): Promise<{ user: Me | null; offline: boolean; registration: string }> {
  try {
    const r = await get<{ user: Me | null; registration: string }>("/api/auth/me");
    try { localStorage.setItem("zahrada:user", JSON.stringify(r.user)); } catch {}
    return { user: r.user, offline: false, registration: r.registration };
  } catch (e) {
    // offline: trust the last known user so the garden still opens in the field
    if (e instanceof ApiError && e.status === 0) {
      try { return { user: JSON.parse(localStorage.getItem("zahrada:user") || "null"), offline: true, registration: "invite" }; } catch {}
    }
    return { user: null, offline: e instanceof ApiError && e.status === 0, registration: "invite" };
  }
}

export function renderAuth(root: HTMLElement, onDone: (u: Me) => void, opts: { registration: string; resetToken?: string; onDemo?: () => void }) {
  let mode: "login" | "register" | "forgot" | "reset" = opts.resetToken ? "reset" : "login";
  const page = h("div", { class: "page" });
  root.replaceChildren(page);

  function draw() {
    const msg = h("p", { class: "err", role: "alert" });
    const okMsg = h("p", { class: "ok-msg", role: "status" });
    const email = h("input", { id: "authEmail", type: "email", autocomplete: "email", required: true, inputmode: "email" }) as HTMLInputElement;
    const pass = h("input", { id: "authPass", type: "password", autocomplete: mode === "login" ? "current-password" : "new-password", minLength: 8, required: true }) as HTMLInputElement;
    const submit = h("button", { class: "btn primary block", type: "submit" },
      mode === "login" ? "Přihlásit se" : mode === "register" ? "Vytvořit účet" : mode === "forgot" ? "Poslat odkaz" : "Nastavit heslo");
    const form = h("form", { class: "card", novalidate: true },
      mode === "login" || mode === "register"
        ? h("div", { class: "tabs", role: "tablist" },
            h("button", { type: "button", role: "tab", "aria-selected": String(mode === "login"), onclick: () => { mode = "login"; draw(); } }, "Přihlášení"),
            h("button", { type: "button", role: "tab", "aria-selected": String(mode === "register"), onclick: () => { mode = "register"; draw(); } }, "Nový účet"))
        : h("h2", {}, mode === "forgot" ? "Zapomenuté heslo" : "Nové heslo"),
      mode !== "reset" ? h("label", { class: "field" }, h("span", {}, "E-mail"), email) : null,
      mode !== "forgot" ? h("label", { class: "field" }, h("span", {}, mode === "login" ? "Heslo" : "Heslo (aspoň 8 znaků)"), pass) : null,
      mode === "register" && opts.registration !== "open" ? h("p", { class: "hint" }, "Registrace je zatím jen pro pozvané e-maily.") : null,
      msg, okMsg, submit,
      mode === "login" ? h("button", { type: "button", class: "linkbtn", onclick: () => { mode = "forgot"; draw(); } }, "Zapomněl jsem heslo") : null,
      mode === "forgot" || mode === "reset" ? h("button", { type: "button", class: "linkbtn", onclick: () => { mode = "login"; draw(); } }, "Zpět na přihlášení") : null,
    );
    form.addEventListener("submit", async (ev) => {
      ev.preventDefault();
      msg.textContent = ""; okMsg.textContent = "";
      submit.disabled = true;
      try {
        if (mode === "forgot") {
          await post("/api/auth/reset-request", { email: email.value });
          okMsg.textContent = "Pokud účet existuje, poslal jsem na e-mail odkaz pro nové heslo.";
        } else if (mode === "reset") {
          await post("/api/auth/reset-confirm", { token: opts.resetToken, password: pass.value });
          history.replaceState(null, "", "/");
          const me = await get<{ user: Me }>("/api/auth/me");
          onDone(me.user);
        } else {
          const r = await post<{ user: Me }>(mode === "login" ? "/api/auth/login" : "/api/auth/register", { email: email.value, password: pass.value });
          try { localStorage.setItem("zahrada:user", JSON.stringify(r.user)); } catch {}
          onDone(r.user);
        }
      } catch (e) {
        msg.textContent = e instanceof Error ? e.message : "Nepovedlo se.";
      } finally { submit.disabled = false; }
    });
    page.replaceChildren(h("div", { class: "page-inner" },
      h("div", { class: "logo", html: I.tree + "<b>Zahrada</b>" }),
      h("p", { class: "hint" }, "Mapa rostlin na tvé zahradě. Parcely z katastru, poloha z GPS, odrůdy a fotky štítků. Funguje i bez signálu."),
      form,
      opts.onDemo && (mode === "login" || mode === "register") ? h("div", { class: "card" },
        h("h2", {}, "Jen se podívat?"),
        h("p", { class: "hint" }, "Vyzkoušej aplikaci na ukázkové zahradě bez přihlášení. Můžeš přidávat rostliny, fotky i parcely, ale po odchodu se nic neuloží."),
        h("button", { type: "button", class: "btn ghost block", onclick: opts.onDemo, html: I.leaf + "<span>Vyzkoušet bez přihlášení</span>" })) : null));
    (mode === "reset" ? pass : email).focus();
  }
  draw();
}